import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { deriveIsAdmin } from '@/config';
import authApi from '@/store/services/authApi';

const AUTH_STATUS = {
    AUTHENTICATED: 'authenticated',
    LOADING: 'loading',
    UNAUTHENTICATED: 'unauthenticated',
};

const getMeSelector = authApi.endpoints.getMe.select(undefined);

export const deriveAuthStatus = (queryState) => {
    const loading =
        queryState?.isUninitialized || queryState?.isLoading || (queryState?.isFetching && !queryState?.data);
    if (loading) {
        return AUTH_STATUS.LOADING;
    }
    if (queryState?.data) {
        return AUTH_STATUS.AUTHENTICATED;
    }
    return AUTH_STATUS.UNAUTHENTICATED;
};

const useAuth = () => {
    const queryState = useSelector(getMeSelector);
    return useMemo(
        () => ({
            authStatus: deriveAuthStatus(queryState),
            isAdmin: deriveIsAdmin(queryState?.data),
            isAuthenticated: Boolean(queryState?.data),
            user: queryState?.data ?? null,
        }),
        [queryState],
    );
};

export { AUTH_STATUS, useAuth };
